import { useQueryClient } from "@tanstack/react-query";
import { useAppMutation } from "@shared/hooks/useAppMutation";
import { useTranslation } from "react-i18next";
import { notifications } from "@mantine/notifications";
import { authMutations, authQueries } from "../api/auth.queries";

export function useProfileMutation() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useAppMutation({
    errorToast: "local",
    ...authMutations.updateProfile(),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: authQueries.me().queryKey,
      });
      notifications.show({
        title: t("auth.success"),
        message: t("auth.profileUpdated"),
        color: "green",
        autoClose: 3000,
      });
    },
    onError: (error) => {
      const message =
        error instanceof Error ? error.message : t("auth.updateFailed");
      notifications.show({
        title: t("auth.error"),
        message,
        color: "red",
        autoClose: 3000,
      });
    },
  });
}
